<template>
    <div class="container-login form-login-meio">
        <div class="p-d-flex p-jc-center"> 
            <div>
                <div class="p-d-flex p-jc-center p-mb-5">
                    <a href="/login">
                        <img alt="Logo" src="@/assets/logo.png" />
                    </a>
                </div>
                <div class="card p-fluid p-shadow-3" style="width: 25rem;">
                    <h5 class="p-pt-4 p-d-flex p-jc-center">Criar senha para Ativação do Dispositivo</h5>
                    <div class="p-field">					
                         <span class="p-input-icon-left">
                            <i class="pi pi-user"/>                       
                            <InputText v-model.trim="email" type="text" placeholder="CPF ou Email" aria-describedby="email-erro" />                            
                        </span>
                        <small id="email-erro" class="p-invalid" v-if="email === '' && enviandoForm">Informe o cpf ou email</small>
                    </div>       
                    <div class="p-field p-mt-4">					
                        <span class="p-input-icon-left">
                            <i class="pi pi-lock" />                       
                            <InputText v-model.trim="senha" type="password" placeholder="Senha" aria-describedby="email-erro" />                            
                        </span>
                        <small id="email-erro" class="p-invalid" v-if="senha === '' && enviandoForm">Informe a senha</small>  
                    </div>
                    <div class="p-field">					
                        <span class="p-input-icon-left">
                            <i class="pi pi-lock" />                       
                            <InputText v-model.trim="repetirSenha" type="password" placeholder="Repetir senha" aria-describedby="email-erro" />                            
                        </span>
                        <small id="email-erro" class="p-invalid" v-if="repetirSenha === '' && enviandoForm">Informe a senha</small>  
                    </div>   
                    <div class="p-grid p-mt-3 p-mb-4">
                        <div class="p-col-12">
                            <Button label="Enviar" @click="enviar"/>
                        </div>
                    </div>	
                    <Message severity="error" v-if="mensagemErro !== ''">{{ mensagemErro }}</Message>
                    <Message severity="info" v-if="mensagemSucesso !== ''">{{ mensagemSucesso }}</Message>
                </div>
                <div class="p-text-center" style="color:#F9B720">Info Kings</div>
                <div v-if="exibirSpin" class="p-text-center"><i class="pi pi-spin pi-spinner" style="fontSize: 2rem; color:#F9B720"></i></div>
            </div>
        </div>
    </div> 
</template>

<script>
import DispositivoService from '@/service/DispositivoService';
import { mapActions } from 'vuex';
import http from '@/plugins/axios/axios';

export default {
    dispositivoService: null,  
    data() {
        return {            
            exibirSpin: false,
            enviandoForm: false,           
            mensagemErro: '',
            mensagemSucesso: '',  
            codigoRecuperarSenha: '',          
            email: '',
            senha: '',
            repetirSenha: '',
            dadosAtivacao: null
        }
    },    
    methods: {
        ...mapActions('sessao', ['criarSessao', 'limparSessao']),
        /**
         * 
         */
        enviar() {
            this.exibirSpin = true;
            this.enviandoForm = true;         
            this.mensagemSucesso = '';
            this.mensagemErro = '';                         
            if(this.email != '' && this.senha != '' && this.repetirSenha != '') {         
                let dados = {
                    cpfEmail: this.email,
                    senha: this.senha,
                    senhaRepetir: this.repetirSenha,
                    codigoAtivacao: this.dadosAtivacao.codigoAtivacao,
                    codigoEmpresa: this.dadosAtivacao.codigoEmpresa,
                    ativacao: this.dadosAtivacao.ativacao,
                    descricao: 'Web Browser'                   
                }   
                this.dispositivoService.ativar(dados)
                    .then(resp => {
                        this.exibirSpin = false;
                        http.defaults.headers.common['Authorization'] = 'Bearer '+resp.data.token.access;  
                        http.defaults.headers.common['X-IKPonto-Request'] = 'onapp';                                         
                        this.criarSessao(resp.data);                        
                        this.$router.push('/');
                    })
                    .catch(erro => {       
                        this.exibirSpin = false;     
                        this.mensagemErro = erro.response.data.mensagem;
                    });               
            } else {
                this.exibirSpin = false;
            }           
        },
        /**
         * 
         */
        validarCodigoAtivacao() {
            let jsonAtivacao = sessionStorage.getItem('SUCESSO_ATIVACAO');
            this.dadosAtivacao = JSON.parse(jsonAtivacao);
            if(!this.dadosAtivacao) {
                this.$router.push('/login');
            }
        } 
    },
    created() {
        this.dispositivoService = new DispositivoService();       
        this.validarCodigoAtivacao();     
    }
}
</script>

<style scoped>    
    
    html, body {
        height: 100vh !important;
        margin: 0px !important;  
    }

    .container-login {
        height: 100vh !important;
        background-color: #232839 !important;
    }

    .form-login-meio {
        padding-top: 130px;
    }

    .text-help {
        font-size: 0.9rem !important;
    }

</style>